<script setup lang="ts">
interface Props {
  progress?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  progress: () => ['', '0'],
})

console.log(props.progress)

let currentPart = props.progress[0]
let currentStep = isNaN(Number(props.progress?.[1])) ? 0 : Number(props.progress?.[1] ?? 0)

interface ProgressItem {
  name: string
  step: number
  length: number
  percentage: number
}

const partOrder = ['past', 'present', 'cut', 'future']

const progressArray = generateProgressArray(currentPart, currentStep)
console.table(progressArray)

function generateProgressArray(currentPart: string, curentStep: number): ProgressItem[] {
  return partOrder.map((partName, index) => {
    // prettier-ignore
    const length = partName === 'future' && currentPart == 'future-p' ? 12 :
                   partName === 'future' ? 11 :
                   partName === 'past' ? 6 :
                   partName === 'present' ? 4 :
                   partName === 'cut' ? 5 : 0;
    const name = currentPart.split('-')[0]
    let step = name == partName ? curentStep : partOrder.indexOf(name) > index ? length : 0
    const percentage = Math.min(100, (step / length) * 100)
    return { name: partName, step, length, percentage }
  })
}
</script>

<template>
  <div class="flex gap-2 w-full h-[8px] sm:h-[12px] text-center">
    <template v-for="progress in progressArray">
      <div :class="progress.name" class="flex-1">
        <div class="h-full w-full bg-gray-50 rounded-md shadow-sm">
          <div
            class="h-full bg-[#43638C] rounded-md shadow-sm"
            :style="{ width: Math.ceil(progress.percentage) + '%' }"
          ></div>
        </div>
      </div>
    </template>
  </div>
</template>

<style scoped>
.part-rounded {
  border-radius: 5px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.03);
}
</style>
